module.exports = __webpack_public_path__ + "static/img/qwh_only_logo.6a71fea8.png";